// extracted by mini-css-extract-plugin
export default {"swiperContainer":"BannerSwiper-module__swiperContainer__k5c0q"};